import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import { GET_USER } from "~/clientState/providers/operations/user";
import type { GetUserQuery } from "~/generated/graphql";

const useGetUserQuery = (): UseQueryResult<GetUserQuery> => {
  return useQuery<GetUserQuery>(GET_USER);
};

export default useGetUserQuery;
